import { ManagementFormAPI } from '@business/api/managementForm';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { ManagementFormResponse, FormForwardUserStatus, ManagementFormID, FormForwardType } from '@business/entities/managementForms';
import { UserId } from '@business/entities/account';
// import { ManagementFormCommentAPI } from '@business/api/management_form_comments';
import { FormId } from '@business/entities/managementFormTemplate';
import { FolderId } from '@business/entities/library';
import { ManagementFormCommentAPI } from '@business/api/management_form_comments';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class ManagementFormBloc extends BaseBloc {
  private readonly itemsRepo = new Repository<ManagementFormResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.itemsRepo.items$;
  readonly selectForm = this.itemsRepo.selectItem;

  onReset() {
    this.itemsRepo.reset();
  }

  createForm = (name: string, folderId: FolderId, form: FormId) => {
    return ManagementFormAPI.createForm(name, folderId, form).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_form_file'),
      }),
    );
  };

  forwardForm = (id: FormId, users: UserId[], comment?: string, type?: FormForwardType) => {
    return ManagementFormAPI.forwardForm(id, users, comment, type).pipe(
      handleMessage({
        type: requestMessage('create_form_file'),
      }),
    );
  };

  fetchForms = () => {
    return ManagementFormAPI.fetchForms().pipe(this.itemsRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_form_error') }));
  };

  fetchForm = (id: FormId) => {
    return ManagementFormAPI.fetchForm(id).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),

      handleMessage({ error: requestMessage('fetch_form_error') }),
    );
  };

  deleteForm = (id: FormId) => {
    return showDeleteConfirmation('Delete Form', 'Do you want to delete this form?').pipe(
      switchMap(() => ManagementFormAPI.deleteForm(id)),
      this.itemsRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_form'),
      }),
    );
  };

  multiDelete = (data: any) => {
    return showDeleteConfirmation('Delete Form', 'Do you want to delete this form?').pipe(
      switchMap(() => ManagementFormAPI.multiDelete(data)),
      this.itemsRepo.ops.reset(),
      handleMessage({
        type: requestMessage('delete_form'),
      }),
    );
  };

  saveFormValues = (id: string, data: string, status: FormForwardUserStatus) => {
    return ManagementFormAPI.saveFormValues(id, data, status).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('save_form_values'),
      }),
    );
  };

  updateForwardedStatus = (id: string, status: FormForwardUserStatus, finalize?: boolean) => {
    return ManagementFormAPI.updateForwardedStatus(id, status, finalize).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('save_form_values'),
      }),
    );
  };

  createComment = (data: { comment: string; formId: ManagementFormID; user: UserId }) => {
    return ManagementFormCommentAPI.createComment(data).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_comment'),
      }),
    );
  };

  fetchComments = (formId: ManagementFormID) => {
    return ManagementFormCommentAPI.fetchComments(formId).pipe(handleMessage({ error: requestMessage('fetch_form_error') }));
  };
}
